// Environment variables - must be prefixed with REACT_APP_ to be accessible in browser
// Access via process.env.REACT_APP_ENV to differentiate between environments
export const ENV = process.env.REACT_APP_ENV || 'development';

// API Base URLs - can be customized per environment via .env files
export const ApiBaseUrl = process.env.REACT_APP_API_BASE_URL || "https://clinic-api.khalidelewa.com";
export const ApiBaseUrl2 = process.env.REACT_APP_API_BASE_URL2 || "http://localhost:5000";
export const ImageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL || ApiBaseUrl;

// Example: Different configurations based on environment
export const config = {
  env: ENV,
  isNajma: ENV === 'najma',
  isNpm: ENV === 'npm',
  apiBaseUrl: ApiBaseUrl,
  apiBaseUrl2: ApiBaseUrl2,
  imageBaseUrl: ImageBaseUrl,
};